<template lang="pug">
  .select-box(:class="classObject")
    button.select-box__content(
      :class="{'selected': isSelected}"
      type="button"
      @click="route && $router.push(route)"
    )
      .select-box__title {{title}}
      .select-box__value(v-show="value") {{value}}
      .select-box__avatar.avatar.loading(v-if="isSelected && showAvatar" ref="avatar")
        img.avatar__img(:src="avatarChecker(avatarUrl)" :alt="value")
      .select-box__placeholder(v-show="!value")
        span.select-box__placeholder-text {{placeholder}}
        v-icon.select-box__placeholder-icon(name="chevron-right")

    .select-box__chevron-icon(v-show="!value")
      v-icon.select-box__clear-icon(name="chevron-right")
    button.select-box__clear(v-show="value" @click="$emit('clear')")
      v-icon.select-box__clear-icon(name="x")
</template>

<script>
import avatarChecker from '@/mixins/avatar-checker'
import imageOnload from '../mixins/image-onload'

export default {
  mixins: [avatarChecker, imageOnload],
  props: {
    title: {type: String},
    showAvatar: {type: Boolean},
    avatarUrl: {type: String},
    value: {type: String},
    placeholder: {type: String},
    route: {type: String},
    disabled: {type: Boolean},
  },
  computed: {
    classObject() {
      return {
        'select-box--avatar': this.showAvatar && this.isSelected,
        'disabled': this.disabled,
      }
    },
    isSelected() {
      return !!this.value;
    }
  },
  watch: {
    avatarUrl() {
      this.$nextTick(() => this.imageOnload({
        container: this.$refs?.avatar,
        className: 'loading'
      }))
    }
  },
  mounted() {
    this.$nextTick(() => this.imageOnload({
      container: this.$refs?.avatar,
      className: 'loading'
    }));
  }
};
</script>
